import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Chip from '@material-ui/core/Chip'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'

const useWorkspaceProgressStatusChipStyles = makeStyles((theme: Theme) => ({
    workspaceProgressStatusChip: {
        textTransform: 'uppercase',
        fontSize: pxToRem(12),
        color: theme.palette.common.white,
        borderRadius: 4,
        padding: theme.spacing(0.625, 0),
        fontWeight: 500,
        boxSizing: 'content-box',
        maxWidth: pxToRem(112),
        '& > span.MuiChip-label': {
            padding: theme.spacing(0, 1.25),
        },
    },
}))

export type WorkspaceProgressStatus =
    | 'in review'
    | 'review needed'
    | 'complete'
    | 'new'
    | 'needs coordination'
    | 'complete'
    | 'draft'
    | 'published'

const ChipColorMap: Record<string, string> = {
    'in review': '#686B8C',
    'review needed': '#C25130',
    complete: '#039590',
    new: '#2F4858',
    'needs coordination': '#EB9928',
    active: '#7FC162',
    draft: '#C8C8C8',
    published: '#0098D6',
}
export interface WorkspaceProgressStatusChipProps {
    variant: WorkspaceProgressStatus
}

const WorkspaceProgressStatusChip: React.FC<WorkspaceProgressStatusChipProps> = ({
    variant = 'new',
}) => {
    const classes = useWorkspaceProgressStatusChipStyles()

    return (
        <HoverTooltip text={variant as string} placements={['bottom', 'top']}>
            <Chip
                label={variant}
                size="small"
                className={classes.workspaceProgressStatusChip}
                style={{
                    backgroundColor: ChipColorMap[variant],
                }}
            />
        </HoverTooltip>
    )
}

export default WorkspaceProgressStatusChip
